import { createSelector } from '@reduxjs/toolkit';
import { selectStrategy } from '../../store/selectors';

export const selectStrategyDetailsState = createSelector(selectStrategy, (strategyState) => strategyState.strategyDetails);

export const selectStrategyDetails = createSelector(selectStrategyDetailsState, (strategyDetails) => strategyDetails.details);
